/**
 * @file service.tsx
 * @description Компонент страницы каталога сервисов для управления сущностями сервисов в системе управления 
 * задачами. Предоставляет базовую функциональность управления сервисами для создания, редактирования и 
 * просмотра сервисов. Включает минималистичное табличное представление, отображающее только названия 
 * сервисов, предназначенное для простого администрирования каталога сервисов. Сервисы используются как 
 * справочные сущности по всей системе для категоризации задач, багов и требований.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@forms/service', '@utils/table-view']
 * @related-files ['@forms/service/index.tsx']
 */

import { ServiceForm } from '@forms/service';
import { getDefaultCell } from '@utils/table-view';

export const title = 'Сервис';
export const searchModalTitle = 'Выбор сервиса';
export const type = 'Service';
export const path = 'service';
export const form = ServiceForm;

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Наименование' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];
